import { render, staticRenderFns } from "./imageExhibition.vue?vue&type=template&id=5aaf4d4c&scoped=true&"
import script from "./imageExhibition.vue?vue&type=script&lang=js&"
export * from "./imageExhibition.vue?vue&type=script&lang=js&"
import style0 from "./imageExhibition.vue?vue&type=style&index=0&id=5aaf4d4c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf4d4c",
  null
  
)

export default component.exports